import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormItemContainer from '../../Global/Containers/FormItemContainer';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { withApollo } from 'react-apollo';
import CommentList from './CommentList';
import Button from '@material-ui/core/Button';
import SpacingStyles from '../../../styles/helpers/spacing';
import combineStyles from '../../../utils/combineStyles';
import ButtonStyles from '../../../styles/button';
import { userSubscribedToComments } from './helpers';
import { AppContext } from '../../../AppProvider';
import * as Mutations from '../../../graphQL/mutations/shipmentMutations';
import AllCommentsModal from './AllCommentsModal';
import CommentInput from './CommentInput';
import { orgUsersByOrgIdQuery } from '../../../graphQL/queries/orgUserQueries';
import { formatUsers } from './helpers';
import CommentSubscribedButton from './CommentSubscribedButton';
import NotificationSnackbar from './../../common/NotificationSnackbar';
import LoadingIndicator from '../../LoadingIndicator';
import SingleCommentModal from './SingleCommentModal';
import EditCommentModal from './CommentEdit.modal';

const commentStyles = theme => ({
  moreCommentsButton: {
    padding: theme.spacing.unit * 3
  }
});
export class Comments extends Component {
  static propTypes = {
    comments: PropTypes.array,
    shipmentId: PropTypes.string.isRequired,
    subscribers: PropTypes.array.isRequired,
    onUpdate: PropTypes.func.isRequired
  };
  state = {
    userId: null,
    subscribed: false,
    allCommentsModalOpen: false,
    users: [],
    comments: this.props.comments.reverse(),
    commentsLoaded: false,
    commentsLoading: false,
    errors: null,
    displaySingleCommentModal: false,
    displayEditCommentModal: false,
    singleComment: {},
    editingComment: {}
  };
  async componentDidMount() {
    const {
      user: { id },
      currentOrgId
    } = this.context.globalProps;
    const { subscribers, client: ApolloClient } = this.props;
    try {
      const {
        data: {
          orgUser: { all: allUsers }
        }
      } = await ApolloClient.query({
        query: orgUsersByOrgIdQuery,
        variables: { orgId: currentOrgId }
      });
      const users = formatUsers(allUsers);

      this.setState({
        userId: id,
        subscribed: userSubscribedToComments(id, subscribers),
        users,
        commentsLoaded: true
      });
    } catch (e) {
      this.setState({ errors: e });
    }
  }
  componentDidUpdate(prevProps) {
    const { comments } = this.props;
    if (prevProps.comments !== comments) {
      this.setState({ comments: comments.reverse() });
    }
  }
  toggleSubscribe = async () => {
    const { client: ApolloClient, shipmentId } = this.props;
    const { userId, subscribed } = this.state;
    const newSubscriptionStatus = !subscribed;
    let updateMutation = Mutations.subscribeToComments;

    if (!newSubscriptionStatus) {
      updateMutation = Mutations.unSubscribeToComments;
    }
    try {
      await ApolloClient.mutate({
        mutation: updateMutation,
        variables: {
          shipmentId,
          userIds: [userId]
        }
      });
      this.setState({ subscribed: newSubscriptionStatus });
    } catch (e) {
      this.setState({ errors: e });
    }
  };
  toggleAllCommentsModal = display => {
    this.setState({ allCommentsModalOpen: display });
  };
  _handleCommentCreate = async comment => {
    this.setState({ commentsLoading: true });
    const { client: ApolloClient, shipmentId, onUpdate } = this.props;
    try {
      await ApolloClient.mutate({
        mutation: Mutations.saveComment,
        variables: {
          comment: {
            shipmentId,
            content: comment
          }
        }
      });
      await onUpdate();
      this.setState({ commentsLoading: false });
    } catch (e) {
      if (e.graphQLErrors) {
        const errorOk = e.graphQLErrors.find(error => {
          if (error.message === 'GraphQL.ExecutionError: LinkAlreadyExists') {
            return true;
          }
          return false;
        });
        if (!errorOk) {
          this.setState({ errors: e, commentsLoading: false });
        } else {
          await onUpdate();
          this.setState({ commentsLoading: false });
        }
      }
    }
  };
  _handleViewSingleComment = (comment, options) => {
    this._toggleModalDisplay('displaySingleCommentModal');
    this.setState({ singleComment: { comment, options } });
  };
  _handleEditCommentClick = comment => {
    this.setState({ editingComment: comment, displayEditCommentModal: true });
  };
  _handleCommentUpdate = async (id, content) => {
    this.setState({ commentsLoading: true });
    const { client: ApolloClient, shipmentId, onUpdate } = this.props;
    try {
      await ApolloClient.mutate({
        mutation: Mutations.saveComment,
        variables: {
          comment: {
            shipmentId,
            content,
            id
          }
        }
      });
      await onUpdate();
      this.setState({
        commentsLoading: false,
        displayEditCommentModal: false,
        editingComment: {}
      });
    } catch (e) {
      this.setState({ errors: e, commentsLoading: false });
    }
  };
  _toggleModalDisplay = modalType => {
    const currentModalStatus = this.state[modalType];
    this.setState({ [modalType]: !currentModalStatus, menuElement: null });
  };
  _handleCommentDelete = async comment => {
    const { client: ApolloClient, onUpdate, comments } = this.props;
    this.setState({ commentsLoading: true });
    try {
      const {
        data: {
          shipment: { deleteComment }
        }
      } = await ApolloClient.mutate({
        mutation: Mutations.deleteComment,
        variables: {
          shipmentCommentId: comment.id
        }
      });
      if (deleteComment) {
        const updatedCommentList = comments.filter(existingComment => {
          return existingComment.id !== comment.id;
        });
        await onUpdate(updatedCommentList);
        this.setState({ commentsLoading: false });
      }
    } catch (e) {
      this.setState({ errors: e, commentsLoading: false });
    }
  };
  _handleErrorOnClose = () => {
    this.setState({ errors: null });
  };
  render() {
    const { t, classes, comments } = this.props;
    const {
      allCommentsModalOpen,
      users,
      commentsLoaded,
      subscribed,
      commentsLoading,
      displaySingleCommentModal,
      displayEditCommentModal,
      singleComment,
      editingComment
    } = this.state;
    const commentsToDisplay = comments.slice(0, 3);

    return (
      commentsLoaded && (
        <FormItemContainer
          title={t('Comments')}
          secondaryAction={
            <CommentSubscribedButton
              subscribed={subscribed}
              onClick={this.toggleSubscribe}
            />
          }
          classes={{ contents: classes.noPadding }}
        >
          <CommentInput onSave={this._handleCommentCreate} users={users} />
          <CommentList
            comments={commentsToDisplay}
            users={users}
            onDelete={this._handleCommentDelete}
            onEditClick={this._handleEditCommentClick}
            onViewSingleComment={this._handleViewSingleComment}
          />
          {comments.length > 3 && (
            <div className={classes.moreCommentsButton}>
              <Button
                variant="outlined"
                color="primary"
                className={classnames(
                  classes.outlinedButton,
                  classes.noMarginBottom
                )}
                classes={{ label: classes.buttonLabel }}
                onClick={() => {
                  this.toggleAllCommentsModal(true);
                }}
              >
                {t('View all comments')}
              </Button>
            </div>
          )}
          <AllCommentsModal
            open={allCommentsModalOpen}
            onClose={() => {
              this.toggleAllCommentsModal(false);
            }}
            comments={this.props.comments}
            users={users}
            onCreate={this._handleCommentCreate}
            onDelete={this._handleCommentDelete}
            onEditClick={this._handleEditCommentClick}
            subscribed={subscribed}
            toggleSubscribe={this.toggleSubscribe}
          />
          {singleComment && (
            <SingleCommentModal
              open={displaySingleCommentModal}
              onEditClick={this._handleEditCommentClick}
              comment={singleComment}
              onClose={() => {
                this._toggleModalDisplay('displaySingleCommentModal');
              }}
            />
          )}
          <EditCommentModal
            open={displayEditCommentModal}
            options={editingComment}
            onCommentUpdate={this._handleCommentUpdate}
            onClose={() => {
              this._toggleModalDisplay('displayEditCommentModal');
            }}
          />
          <NotificationSnackbar
            open={Boolean(this.state.errors)}
            handleSnackbarClose={this._handleErrorOnClose}
            message={t('A system error occured saving comments')}
          />
          {commentsLoading && <LoadingIndicator />}
        </FormItemContainer>
      )
    );
  }
}
Comments.contextType = AppContext;
const translatedComments = withNamespaces()(withApollo(Comments));
export default withStyles(
  combineStyles(commentStyles, ButtonStyles, SpacingStyles)
)(translatedComments);
